import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CpfCnpjPipe } from '../../../../shared/pipes/cpf-cnpj.pipe';
import { RelatorioCFOPAgrupadoStruct } from '../../../../shared/services/structs/repo-dfe/relatorio-cfop-agrupado.struct';
import { MatTableModule } from '@angular/material/table';
import { AlertCardComponent } from '../../../../shared/components/alert-card/alert-card.component';
import { RelatorioCfopService } from '../../../../shared/services/apis/repo-dfe/relatorio-cfop.service';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { Empresa } from '../../../../shared/services/models/usuario/empresa.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';


@Component({
  selector: 'app-relatorio-cfop-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    CurrencyPipe,
    MatTableModule,
    MatTooltipModule,
    CpfCnpjPipe,
    DatePipe,
    AlertCardComponent,
    LoadingBoxComponent,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()],
  templateUrl: './relatorio-cfop-modal.component.html',
  styleUrls: ['./relatorio-cfop-modal.component.css']
})
export class RelatorioCfopModalComponent implements OnInit {

  displayedColumns: string[] = ['cfop', 'valorContabil', 'valorCancelado'];
  public readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };
  public relatorio: RelatorioCFOPAgrupadoStruct[] = [];
  public filtros: any;
  public display: any;
  public _isLoading: boolean = false;
  public empresasVisiveis: any[] = [];
  public totalEmpresasOcultas: number = 0;
  public tooltipEmpresasOcultas: string = '';

  constructor(
    public dialogRef: MatDialogRef<RelatorioCfopModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private relatorioCfopService: RelatorioCfopService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.filtros = this.data.filtros;
    this.display = this.data.display;

    if (this.display?.empresas) {
      const limite = 4; // Mostra até 4 empresas
      this.empresasVisiveis = this.display.empresas.slice(0, limite);
      this.totalEmpresasOcultas = Math.max(0, this.display.empresas.length - limite);

      // Monta o texto do tooltip para as empresas restantes
      if (this.totalEmpresasOcultas > 0) {
        this.tooltipEmpresasOcultas = this.display.empresas
          .slice(limite)
          .map((e: Empresa) => `${e.nomeEmpresa} (${e.cnpj})`)
          .join('\n');
      }
    }

    this.carregarDados();
    console.log(this.data);
  }
  fechar(): void {
    this.dialogRef.close();
  }
  getStatusDescricao(status: boolean | null): string {
    if (status === true) return 'Apenas Canceladas';
    if (status === false) return 'Apenas Autorizadas';
    return 'Todas';
  }
  getNomeEmpresa(cnpj: string): string {
    // Busca na lista completa de empresas enviada pelo pai
    const empresa = this.display?.empresas?.find((e: Empresa) => e.cnpj === cnpj);
    return empresa ? empresa.nomeEmpresa : '';
  }

  carregarDados(): void {
    this._isLoading = true;
    this.relatorioCfopService.getRelatorioCfop(this.filtros).subscribe({
      next: (response) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.relatorio = response.listaRelatorioCFOPAgrupadoStruct || [];
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao gerar o relatório de CFOP.', AlertType.error);
      }
    });
  }

  imprimir(): void {
    // 1. Seleciona o conteúdo que queremos imprimir
    const conteudoParaImprimir = document.querySelector('.modal-container');

    if (conteudoParaImprimir) {
      // 2. Abre uma janela pop-up em branco
      const janelaImpressao = window.open('', '', 'height=600,width=800');

      if (janelaImpressao) {
        // 3. Monta o HTML da nova janela
        // Copiamos os estilos do <head> da aplicação atual para garantir que fontes e cores venham junto
        janelaImpressao.document.write(`
          <html>
            <head>
              <title>Relatório CFOP</title>
              <base href="/">
              ${document.head.innerHTML} 
              <style>
                /* ESTILOS ESPECÍFICOS PARA A JANELA DE IMPRESSÃO */
                body { 
                  background-color: white; 
                  -webkit-print-color-adjust: exact; 
                  print-color-adjust: exact;
                  margin: 20px;
                }
                
                /* Removemos o scroll e permitimos altura infinita */
                .modal-container, .modal-content, .table-responsive {
                  height: auto !important;
                  max-height: none !important;
                  overflow: visible !important;
                  display: block !important;
                  width: 100% !important;
                }

                /* Escondemos botões e elementos de UI */
                .modal-header button, 
                .modal-footer, 
                .modal-content::-webkit-scrollbar {
                  display: none !important;
                }

                /* Ajustes de layout para papel */
                .modal-header {
                  border-bottom: 2px solid #000 !important;
                  margin-bottom: 20px !important;
                }
                
                .empresa-card {
                  break-inside: avoid; /* Evita quebrar o card no meio da folha */
                  page-break-inside: avoid;
                  border: 1px solid #ccc !important;
                  margin-bottom: 15px !important;
                  box-shadow: none !important;
                }

                /* Força cor preta para contraste */
                * { color: #000 !important; }
                
                /* Esconde tooltips que possam ter vindo junto */
                .mat-tooltip, .cdk-overlay-container { display: none !important; }
              </style>
            </head>
            <body>
              ${conteudoParaImprimir.outerHTML}
            </body>
          </html>
        `);

        janelaImpressao.document.close();
        janelaImpressao.focus();

        // 4. Aguarda um momento para os estilos carregarem e chama a impressão
        setTimeout(() => {
          janelaImpressao.print();
          janelaImpressao.close();
        }, 500); // 500ms é geralmente suficiente
      }
    }
  }
}
